module.exports = __webpack_public_path__ + "img/logo.aec990dc.svg";